import React, { useState, useEffect } from 'react'
import useStateRef from 'react-usestateref';
import Helper from '../Helper';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Loader from '../Loader';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';

const SubmitOrderRequest = ({ containerObject, templateName, contentId, dataZone }) => {

    const [pwd, setPwd] = useState('');
    const [isRevealPwd, setIsRevealPwd] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [hasError, setHasError, hasErrorRef] = useStateRef(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage, setErrorMessageRef] = useStateRef();
    const [shippingAddressFlag, setShippingAddressFlag] = useState();
    const [billingAddressValue, setBillingAddressValue, billingAddressValueRef] = useStateRef();
    const history = useHistory();
    const profileDetail = useSelector(state => state.getProfileDetails.profileDetails)
    const dispatch = useDispatch();
    const validateRegistration = (key, value) => {
        console.log("line21")
        console.log("hasErrorRef", hasErrorRef.current)

        switch (key) {
            case "firstName":
                var result = Helper.isEmpty(value.trim())
                var validation = "^[a-zA-Z][a-zA-Z-'\\.\\s]*$";
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    var emptyFirstName = document.getElementById("firstName_error")
                    emptyFirstName.innerHTML = "First Name is a required field.";
                    document.getElementById("submit-order-firstName").classList.add("form-error")
                } else if (!regex.test(value.trim())) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    document.getElementById("firstName_error").innerHTML = "First Name is invalid";
                    document.getElementById("submit-order-firstName").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("firstName_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("submit-order-firstName").classList.remove("form-error")
                }
                break;
            case "lastName":
                var result = Helper.isEmpty(value.trim())
                var validation = "^[a-zA-Z0-9][A-Za-z0-9-'\\.\\s]*$";
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    var emptyFirstName = document.getElementById("LastName_error")
                    emptyFirstName.innerHTML = "Last Name is a required field.";
                    document.getElementById("submit-order-lastName").classList.add("form-error")
                } else if (!regex.test(value.trim())) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    document.getElementById("LastName_error").innerHTML = "Last Name is invalid";
                    document.getElementById("submit-order-lastName").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("LastName_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("submit-order-lastName").classList.remove("form-error")
                }
                break;
            case "email":
                var result = Helper.isEmpty(value.trim())
                var validation = "^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\\.)+[A-Za-z]{2,6}$";
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    var emptyErrorMessage = document.getElementById("email_error")
                    emptyErrorMessage.innerHTML = "Email Address is a required field.";
                    document.getElementById("submit-order-email").classList.add("form-error")
                } else if (!regex.test(value.trim())) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    document.getElementById("email_error").innerHTML = "The email address does not appear to be valid. Please use the format mailto:name@domain.xxx.";
                    document.getElementById("submit-order-email").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("email_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("submit-order-email").classList.remove("form-error")
                }
                break;

            case "phoneNumber":
                var result = Helper.isEmpty(value)
                // var validation = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
                // var validation = /^[0-9!-@#$%^~`&*(),.?":{}|<>]+$/
                // var validation = /(?:\+?\d{1,3})?(?:[-.\s()&%$^';]*\d){7,14}/g;
                // var validation = /(?:\+?\d{1,3})?(?:[-.\s()&%$^';a-zA-Z\d]*){7,14}/g;
                var validation = /[a-zA-Z]/g;
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    var emptyFirstName = document.getElementById("phoneNumber_error")
                    emptyFirstName.innerHTML = "Primary Phone is a required field.";
                    document.getElementById("submit-order-phoneNumber").classList.add("form-error")
                } else if (regex.test(value)) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    document.getElementById("phoneNumber_error").innerHTML = "Primary Phone number should be numeric.";
                    document.getElementById("submit-order-phoneNumber").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("phoneNumber_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("submit-order-phoneNumber").classList.remove("form-error")
                }
                break;
            case "eventName":
                var validation = /[!#$%"&|{}~`]/;
                var regex = RegExp(validation);
                var result = Helper.isEmpty(value)
                if (result) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    var emptyFirstName = document.getElementById("eventName_error")
                    emptyFirstName.innerHTML = "List Name is a required field. Special characters cannot be used.";
                    document.getElementById("submit-order-eventName").classList.add("form-error")
                } else if (regex.test(value)) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    document.getElementById("eventName_error").innerHTML = "List Name should not contain special characters.";
                    document.getElementById("submit-order-eventName").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("eventName_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("submit-order-eventName").classList.remove("form-error")
                }
                break;
            case "shippingAddress":
                var result = Helper.isEmpty(value)
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    var emptyFirstName = document.getElementById("shippingAddress_error")
                    emptyFirstName.innerHTML = "Shipping/Mailing address is a required field.";
                    document.getElementById("submit-order-shippingAddress").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("shippingAddress_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("submit-order-shippingAddress").classList.remove("form-error")
                }
                break;
            case "billingAddress":
                var result = Helper.isEmpty(value)
                var regex = RegExp(validation);
                if (result) {
                    setHasError(true)
                    document.getElementById("submit-order-err").classList.remove("d-none")
                    document.getElementById("submit-order-err").classList.add("d-block")
                    var emptyFirstName = document.getElementById("billingAddress_error")
                    emptyFirstName.innerHTML = "Billing address is a required field.";
                    document.getElementById("submit-order-billingAddress").classList.add("form-error")
                } else {
                    var emptyFirstName = document.getElementById("billingAddress_error")
                    emptyFirstName.innerHTML = "";
                    document.getElementById("submit-order-billingAddress").classList.remove("form-error")
                }
                break;
            default:
        }
    }

    function handleSubmit(event) {
        event.preventDefault();
        setHasError(false)
        var actionUrl = event.target.getAttribute('action');
        document.getElementById("submit-order-err").classList.remove("d-block")
        document.getElementById("submit-order-err").classList.add("d-none")
        var existingList = document.getElementById("list_error")
        existingList.innerHTML = ""
        var formData = new FormData(event.target);
        const formValue = Object.fromEntries(formData.entries());
        Object.entries(formValue).map(([key, value], keyIndex) => {
            validateRegistration(key, value)
        })
        console.log("line210", hasErrorRef.current)
        if (!hasErrorRef.current) {
            fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/${actionUrl}`, {
                method: 'POST',
                headers: new Headers({
                    "content-Type": "application/json",
                }),
                body: JSON.stringify(formValue)
            }).then(res => res.json())
                .then(res => {
                    if (res.result === "success") {
                        // setIsLoading(false)
                        dispatch(updateProfileDetailsAction(true,"clearCart"))
                        history.push(res.response)
                    } else {
                        // setIsLoading(false)
                        setHasError(true)
                        document.getElementById("submit-order-err").classList.remove("d-none")
                        document.getElementById("submit-order-err").classList.add("d-block")
                        var existingList = document.getElementById("list_error")
                        existingList.innerHTML = JSON.parse(res.errorMessage).message
                        document.getElementById("submit-order-eventName").classList.add("form-error")
                        var scrollPos = document.getElementById("submit-order-err").offsetTop;
                        window.scrollTo({
                            top: parseInt(scrollPos),
                            behavior: 'smooth'
                        })
                    }
                })
        } else {
            console.log("line220")
        }

    }
    function handleCheckboxValidation(event) {
        var checkFlag = document.getElementById("blankCheckbox").checked
        setShippingAddressFlag(checkFlag)
        var billingField = document.getElementById("submit-order-billingAddress")
        var shippingAddress = document.getElementById("submit-order-shippingAddress").value
        if (checkFlag == true) {
            billingField.classList.add("form-control-bg")
            setBillingAddressValue(shippingAddress)
            billingField.value = billingAddressValueRef.current;
            billingField.setAttribute("readonly", "readonly")
        } else {
            billingField.classList.remove("form-control-bg")
            billingField.removeAttribute("readonly")
            setBillingAddressValue()
            billingField.value = ""
            billingField.removeAttribute("value")
        }

    }

    const handleInputChange = (event) => {
        const value = event.target.value;
        if (shippingAddressFlag == true) {
            setBillingAddressValue(value)
        } else {
            setBillingAddressValue()
        }
    };

    return (
        <>

            <div data-cont-id={containerObject.contentId} data-zone={dataZone} data-page-id={contentId} data-template-name={templateName} className={`vast-plugin-content row  `}>
                <div className="c-container c-delivery-header">
                    <div className="col-12 col-md-11 my-5 mb-md-2 gy-sm-2 my-md-4 mt-md-0">
                        <div className="row">
                            <div className="col-12 col-md-12 text-left mb-3">
                                <h1 className="c-account-heading mb-3">Submit Order Request</h1>
                            </div>
                            <div class="ml-5">
                                <div id="submit-order-err" class="alert alert-danger message message-red d-none" role="alert">
                                    <div className="col-12">
                                        <div id='resultExisitingError' style={{ color: "black" }} dangerouslySetInnerHTML={{ __html: setErrorMessageRef.current }}></div>
                                        <div id='firstName_error' style={{ color: "black" }}></div>
                                        <div id='LastName_error' style={{ color: "black" }}></div>
                                        <div id='email_error' style={{ color: "black" }} ></div>
                                        <div id='phoneNumber_error' style={{ color: "black" }}></div>
                                        <div id='eventName_error' style={{ color: "black" }}></div>
                                        <div id='shippingAddress_error' style={{ color: "black" }}></div>
                                        <div id='billingAddress_error' style={{ color: "black" }}></div>
                                        <div id='list_error' style={{ color: "black" }}></div>
                                    </div>
                                </div>
                            </div>
                            <p className="c-regular-text">
                                Fill in the information below, in order to submit your order request. No payment is due at this time. A representative from our International sales team will review your order and contact you within 1-2 business days.
                            </p>
                        </div>
                    </div>
                    <div className="row">
                        <form method="post" action="internationalCheckout" id="int-checkout" onSubmit={handleSubmit} className="c-account-page" data-hs-cf-bound="true">
                            <div className="col-12 col-md-8">
                                <div className="row g-3 mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="firstName" className="form-label">First Name </label>
                                        <input maxlength="19" name="firstName" id="submit-order-firstName" defaultValue={profileDetail && profileDetail.firstName} type="text" className="form-control" />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="lastName" className="form-label">Last Name / Surname </label>
                                        <input maxlength="19" name="lastName" id="submit-order-lastName" defaultValue={profileDetail && profileDetail.lastName} type="text" className="form-control" />
                                    </div>
                                </div>

                                <div className="row g-3 mb-3">
                                    <div className="col-md-6">
                                        <label className="form-label">Email </label>
                                        <input maxlength="256" name="email" id="submit-order-email" defaultValue={profileDetail && profileDetail.email} type="text" className="form-control" />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="phone" className="form-label">Primary Phone with Country Code </label>
                                        <input maxlength="19" name="phoneNumber" id="submit-order-phoneNumber" type="text" className="form-control" />
                                    </div>
                                </div>

                                <div className="row g-3 mb-3">
                                    <div className="col-md-12">
                                        <label htmlFor="order" className="form-label">Name For Order Request List Name </label>
                                        <input maxlength="40" name="eventName" id="submit-order-eventName" type="text" className="form-control" />
                                        <p className='c-request-reference'><i>
                                            Your request is saved as a shopping list For future reference.
                                        </i></p>
                                    </div>
                                </div>

                                <div className="row g-3 mb-3">
                                    <div className="col-md-12">
                                        <p className="c-regular-text">
                                            <i>
                                                For International shipping addresses include City, Country, Zip code.<br />
                                                For Domestic shipping addresses, provide a street address.<br />We cannot ship to a PO Box.
                                            </i>
                                        </p>
                                    </div>
                                    <i>
                                        <div className="row g-3 mb-4">
                                            <div className="col-12 col-md-6">
                                                <label className='c-request-reference' htmlFor="address">Shipping/Mailing address</label>
                                                <textarea maxlength="254" name="shippingAddress" onChange={handleInputChange} id="submit-order-shippingAddress" className="form-control form-textarea"></textarea>
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <div className="form-check c-register-check" >
                                                    <input name="useShippingForBilling" id="blankCheckbox" type="checkbox" onChange={handleCheckboxValidation} className="form-check-input" />
                                                    <label className="form-check-label" htmlFor="blankCheckbox">
                                                        Use this address for Billing
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row g-3 mb-4">
                                            <div className="col-12 col-md-6">
                                                <label htmlFor="address" className="form-label">Billing address</label>
                                                <textarea maxlength="254" name="billingAddress" value={billingAddressValueRef.current} onChange={handleInputChange} id="submit-order-billingAddress" className="form-control form-textarea"></textarea>
                                            </div>
                                        </div>
                                        <div className="row g-3 mb-4">
                                            <div className="col-12 col-md-12">
                                                <label htmlFor="comments" className="form-label">Additional Comments </label>
                                                <textarea maxlength="254" name="instructions" id="comments" rows="10" className="form-control form-textarea"></textarea>
                                            </div>
                                        </div>
                                        <div className="row g-3 mb-3">
                                            <div className="col-md-6 d-grid">
                                                <button type="submit" id="intlSubmitButton" className="btn btn-primary block">Submit Order Request</button>
                                            </div>
                                        </div>
                                    </i>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default SubmitOrderRequest;